<template>
  <footer class="global-footer">
    <div class="w-1200 mx-auto fz-12 copyright">
      <span>{{ config.company_name }}</span>
      <span>电话：{{ config.tel }}</span>
      <span>地址：{{ config.address }}</span>
      <span class="beian">
        <img src="https://co-image.qichacha.com/upload/chacha/img/20191206/1575615736779577.png" alt="">
         &nbsp;
         {{ config.beian }}
        </span>
    </div>
  </footer>

</template>

<script>
export default {};

</script>

<style scoped lang="scss">

.global-footer {
  width: 100%;
  min-height: 66px;
  padding: 12px 0;

  .copyright {
    min-height: 42px;
    color: #17181b;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px 23px;

    .beian {
      display: flex;
      align-items: center;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/global/Footer.vue